import React, {Component, Fragment, Suspense} from "react";
import ReactDOM from "react-dom";
import Masonry from 'react-masonry-css';
import axios from 'axios'
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactRouterPropTypes from 'react-router-prop-types';
import Autosuggest from 'react-autosuggest';
import ReactHelmet from "../Header/ReactHelmet";
import {Link} from "react-router-dom";
import MainPixelogHeaderCard from "./MainPixelogHeaderCard";
import "./pixelog-main.css";
// import Swiper core and required modules
import SwiperCore, {Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

// install Swiper modules
SwiperCore.use([Navigation]);

import PixelogHeader from "../Header/PixelogHeader";
import AdSense from 'react-adsense-ad';
import MainPixelogChallengesCard from "./MainPixelogChallengesCard";
import MainPixelogChallengeHeaderCard from "./MainPixelogChallengeHeaderCard";

function shuffleArray(array) {
	let i = array.length - 1;
	for (; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
	return array;
}

// * 컴포넌트 렌더링을 위해 500ms를 기다립니다 * /
const MainPixelogCard = React.lazy(
	() =>
		new Promise((resolve, reject) =>
			setTimeout(() => resolve(import ( "./MainPixelogCard")), 500)
		)
);

// * 컴포넌트 렌더링을 위해 500ms를 기다립니다 * /
const MainPixelogTagsCard = React.lazy(
	() =>
		new Promise((resolve, reject) =>
			setTimeout(() => resolve(import ( "./MainPixelogTagsCard")), 500)
		)
);

//메인 리스트 출력
class MainPixelogList extends Component {
	constructor() {
		super();

		this.state = {
			cate: false,
			sort: "7",
			loading: false,
			ItemList: [],
			headerList: [],
			offset: 0,
			limit: 50,
			hasMore: true,
			remain: 50,
			navPosition: 0,
		};
	}

	menuClick = (props) => {
		let cate = this.props.location.state.cate;
		let navPosition;
		if (window.innerWidth < 500) {
			navPosition = $('.swiper-wrapper').css('transform').split(',')[4];
		} else {
			navPosition = 0;
		}
		this.setState({
			cate: cate,
			loading: false,
			navPosition: navPosition,
		})
	}

	showLoginModal = () => {
		showLoginModal();
	}

	//기간 설정 셀렉트 박스
	handleChange = (props) => {
		const {history} = this.props;
		let hasmore;
		let sort = props.target.value;

		axios
			.get(`/home/mainLIKES/${sort}/0/50`)
			.then(({data}) => {

				if (data.piskelsCount < 50) {
					hasmore = false;
				} else {
					hasmore = true;
				}
				this.setState({
					sort: sort,
					loading: true,
					ItemList: [...data.piskels],
					headerList: [...this.state.headerList],
					offset: 50,
					limit: 50,
					remain: data.piskelsCount,
					hasMore: hasmore,
				}, () => {
					history.replace(undefined, {...this.state});
				});
			})
			.catch(e => {
				console.error(e);
				this.setState({
					loading: false
				});
			});

	}

	//최초 실행
	loadData = async () => {
		const {offset, limit, sort} = this.state;
		const {history, location} = this.props;
		let cate;
		if (location.pathname == '/') {
			cate = 'mainNEW';
		} else if (location.pathname == '/diary') {
			cate = 'mainDIARY';
        } else if (location.pathname == '/challenges') {
            cate = 'mainCHALLENGES';
		} else if (location.pathname == '/likes') {
			cate = 'mainLIKES';
		} else if (location.pathname == '/tags') {
			cate = 'mainTAGS';
		} else {
			cate = 'mainHOT';
		}
		let hasmore;
		let one = `/home/${cate}/${sort}/${offset}/${limit}`;
		let two
		if(cate == 'mainCHALLENGES'){
			two = ``;
		}else{
			two = `/home/header/piskels/0/20`;
		}

		const requestOne = axios.get(one);
		const requestTwo = axios.get(two);

		axios
			.all([requestOne, requestTwo])
			.then(
				axios.spread((...responses) => {
					const data = responses[0].data;
					let data_header;
					if(cate == 'mainCHALLENGES') {
						data_header = responses[0].data;
					}else{
						data_header = responses[1].data;
					}
					if (data.piskelsCount < 50) {
						hasmore = false;
					} else {
						hasmore = true;
					}
					if (cate != 'mainLIKES' && cate != 'mainTAGS' && cate != 'mainCHALLENGES') {
						data.piskels = shuffleArray(data.piskels);
					}
					if (cate != 'mainCHALLENGES') {
						data_header.piskels = shuffleArray(data_header.piskels);
					}
					this.setState({
						cate: cate,
						sort: this.state.sort,
						loading: true,
						ItemList: [...this.state.ItemList, ...data.piskels],
						headerList: [...this.state.headerList, ...data_header.piskels],
						offset: this.state.offset + this.state.limit,
						limit: this.state.limit,
						remain: data.piskelsCount,
						hasMore: hasmore,
					}, () => {
						history.replace(undefined, {...this.state});
					});
				})
			)
			.catch(e => {
				console.error(e);
				this.setState({
					loading: false
				});
			});

	};

	loadDataNext = async () => {
		setTimeout(() => {
			const {offset, limit, sort} = this.state;
			const {history, location} = this.props;
			let cate;
			let hasmore;
			if (location.pathname == '/') {
                cate = 'mainNEW';
			} else if (location.pathname == '/diary') {
				cate = 'mainDIARY';
            } else if (location.pathname == '/challenges') {
                cate = 'mainCHALLENGES';
			} else if (location.pathname == '/likes') {
				cate = 'mainLIKES';
			} else if (location.pathname == '/tags') {
				cate = 'mainTAGS';
			} else {
				cate = 'mainHOT';
			}
			axios
				.get(`/home/${cate}/${sort}/${offset}/${limit}`)
				.then(({data}) => {
					if (data.piskelsCount < 50) {
						hasmore = false;
					} else {
						hasmore = true;
					}
                    if (cate != 'mainLIKES' && cate != 'mainTAGS' && cate != 'mainCHALLENGES') {
                        data.piskels = shuffleArray(data.piskels);
                    }
					this.setState({
						cate: cate,
						sort: this.state.sort,
						loading: true,
						ItemList: [...this.state.ItemList, ...data.piskels],
						// headerList: [...this.state.headerList,...data_header.piskels],
						offset: this.state.offset + this.state.limit,
						limit: this.state.limit,
						remain: data.piskelsCount,
						hasMore: hasmore,
					}, () => {
						history.replace(undefined, {...this.state});
					});
				})
				.catch(e => {
					console.error(e);
				});
		}, 100);
	};

	loadDataHeader = async () => {
		setTimeout(() => {
			const {history} = this.props;
			axios
				.get('/home/header/piskels/0/20')
				.then(({data}) => {

					data.piskels = shuffleArray(data.piskels);

					this.setState({
						headerList: [...this.state.headerList, ...data.piskels],
					}, () => {
						history.replace(undefined, {...this.state});
					});
				})
				.catch(e => {
					console.error(e);
				});

		}, 100);
	};

	handleScroll = () => {
		window.scrollTo(0, 0);
	}

	componentDidMount() {
		const {history, location} = this.props;
		window.onbeforeunload = (e) => {
			history.replace(undefined, undefined);
		};
		if (!location.state) {
			this.loadData();
			// this.loadDataHeader();
		} else {
			this.setState({...location.state});
		}
	}//componentDidMount

	shouldComponentUpdate(nextProps, nextState) {
		//만약 다음에 올 리스트가 같을 때
		if (this.state.ItemList == nextState.ItemList) {

			//LIKES 카테고리의 정렬이 다르면 리렌더링
			if (this.state.sort !== nextState.sort) {
				return true;

			} else if (nextProps.location.state !== undefined) {

                // cate가 다르면 리렌더링
				if (this.state.cate !== nextProps.location.state.cate) {

                    // 피스켈 리스트만 업데이트(헤더 그대로 쓰기 위한)
                    // 현재 챌린지가 아닌 상태에서 다음에 올 게 챌린지가 아님
                    if(this.state.cate !== 'mainCHALLENGES' && nextProps.location.state.cate !== 'mainCHALLENGES'){
                        this.handleScroll();
                        const {history} = this.props;
                        let cate = nextProps.location.state.cate;
                        let sort = this.state.sort;
                        let hasmore;
                        axios
                            .get(`/home/${cate}/${sort}/0/50`)
                            .then(({data}) => {
                                if (data.piskelsCount < 50) {
                                    hasmore = false;
                                } else {
                                    hasmore = true;
                                }
                                if (cate !== 'mainLIKES' && cate !== 'mainTAGS' && cate != 'mainCHALLENGES') {
                                    data.piskels = shuffleArray(data.piskels);
                                }
                                this.setState({
                                    cate: cate,
                                    sort: sort,
                                    loading: true,
                                    ItemList: [...data.piskels],
                                    headerList: [...this.state.headerList],
                                    offset: 50,
                                    limit: 50,
                                    remain: data.piskelsCount,
                                    hasMore: hasmore,
                                }, () => {
                                    history.replace(undefined, {...this.state});
                                });
                            })
                            .catch(e => {
                                console.error(e);
                                this.setState({
                                    loading: false
                                });
                            });
                        return false;

                    // 헤더 && 피스켈 모두 업데이트
                    }else{
                        this.handleScroll();
                        const {history} = this.props;
                        let cate = nextProps.location.state.cate;
                        let sort = this.state.sort;
                        let hasmore;
                        let one = `/home/${cate}/${sort}/0/50`;
                        let two
                        if(cate == 'mainCHALLENGES'){
                            two = ``;
                        }else{
                            two = `/home/header/piskels/0/20`;
                        }
                        const requestOne = axios.get(one);
                        const requestTwo = axios.get(two);
                        axios
                            .all([requestOne, requestTwo])
                            .then(
                                axios.spread((...responses) => {

                                    const data = responses[0].data;
                                    let data_header;
                                    if(cate == 'mainCHALLENGES') {
                                        data_header = responses[0].data.piskels;
                                    }else{
                                        data_header = responses[1].data.piskels;
                                    }

                                    if (data.piskelsCount < 50) {
                                        hasmore = false;
                                    } else {
                                        hasmore = true;
                                    }

                                    if (cate !== 'mainLIKES' && cate !== 'mainTAGS' && cate != 'mainCHALLENGES') {
                                        data.piskels = shuffleArray(data.piskels);
                                    }
                                    if (cate != 'mainCHALLENGES') {
                                        data_header = shuffleArray(data_header);
                                    }

                                    this.setState({
                                        cate: cate,
                                        sort: sort,
                                        loading: true,
                                        ItemList: [...data.piskels],
                                        headerList: data_header,
                                        offset: 50,
                                        limit: 50,
                                        remain: data.piskelsCount,
                                        hasMore: hasmore,
                                    }, () => {
                                        history.replace(undefined, {...this.state});
                                    });
                                })
                            )
                            .catch(e => {
                                console.error(e);
                                this.setState({
                                    loading: false
                                });
                            });
                        return false;
                    }
                // cate가 같으면 리렌더링 안함
				} else {
					return false;
				}
			// LIKES 카테고리 컨트롤이 아니고 다음게 같으면 리렌더링 안함
			} else {
				return false;
			}

        // 다음에 올 리스트가 다르다면
		} else {
			//네비바 스크롤 위치 복원
			if (nextProps.location.state !== undefined) {
				let navPosition;
				if (window.innerWidth < 500) {
					navPosition = nextProps.location.state.navPosition;
				} else {
					navPosition = 0;
				}
				$('.swiper-wrapper').css('transform', 'translate3d(' + navPosition + 'px, 0px, 0px)');
			}
			return true;
		}
	}//shouldComponentUpdate

	handleLikeChange = async (v) => {
		const { history } = this.props;
		const targetItemId = v.id; // 업데이트하려는 항목의 id
		if (Array.isArray(this.state.ItemList)) {
			const updatedItemList = this.state.ItemList.map(item => {
				if (item.id === targetItemId) {
					return {...item, likes: v.likes}; // likes 값을 1 증가
				}
				return item; // 변경하지 않을 항목은 그대로 반환
			});
			this.setState({ItemList: updatedItemList}, () => {
				history.replace(undefined, { ...this.state });
			});
		}
	}

	render() {
		const {loading, ItemList, headerList} = this.state;
		const {history, location} = this.props;
		let winUid = window.__pageInfo.uid;
		let pageTitle;
		if (location.pathname == '/') {
			pageTitle = '그림판, 갤러리, 픽셀아트, 그림일기';
		} else if (location.pathname == '/diary') {
			pageTitle = 'DIARY';
        } else if (location.pathname == '/challenges') {
            pageTitle = 'CHALLENGES';
		} else if (location.pathname == '/likes') {
			pageTitle = 'LIKES';
		} else if (location.pathname == '/tags') {
			pageTitle = 'TAGS';
		}
		let list;
		if (location.pathname == '/tags') {
            list = ItemList.map(
                (itemdata, id) => (
                    <Suspense
                        key={id}
                        fallback={
                            // <img className="grid-item" src="/img/pixelog-gif.gif" ></img>
                            <img
                                className="grid-item"
                                src="/img/pixelog-loading-gradation-bg.gif"></img>
                        }
                    >
                        <MainPixelogTagsCard
                            key={itemdata.tid}
                            dataKey={itemdata.key}
                            created_at={itemdata.created_at}
                            cnt={itemdata.cnt}
                            tags={itemdata.tags}
                            type={itemdata.type}
                        />
                    </Suspense>
                )
            );
        } else if (location.pathname == '/challenges') {
            list = ItemList.map(
                (itemdata, id) => (
                    <Suspense
                        key={id}
                        fallback={
                            <img
                                className="grid-item"
                                src="/img/pixelog-loading-gradation-bg.gif"></img>
                        }
                    >
                        <MainPixelogChallengesCard
                            key={itemdata.tid}
                            dataKey={itemdata.key}
                            created_at={itemdata.created_at}
                            cnt={itemdata.cnt}
                            ctags={itemdata.ctags}
                            tags={itemdata.tags}
                            type={itemdata.type}
                            challenge_created_at={itemdata.challenge_created_at}
                            name={itemdata.name}
                            nick={itemdata.nick}
                            uid={itemdata.uid}
                        />
                    </Suspense>
                )
            );
		} else {
			list = ItemList.map(
				(itemdata, id) => (
					<Suspense
						key={id}
						fallback={
							// <img className="grid-item" src="/img/pixelog-gif.gif" ></img>
							<img
								className="grid-item"
								src="/img/pixelog-loading-gradation-bg.gif"
                                alt="로딩중"
                            ></img>
						}
					>
						<MainPixelogCard
							key={itemdata.id}
							id={itemdata.id}
							dataKey={itemdata.key}
							uid={itemdata.uid}
							fps={itemdata.fps}
							frames={itemdata.frames}
							nick={itemdata.nick}
							winUid={winUid}
							likes={itemdata.likes}
							created_at={itemdata.created_at}
							type={itemdata.type}
							onLikeChange={this.handleLikeChange}
                            name={itemdata.name}
						/>
					</Suspense>
				)
			);
		}

		const breakpointColumnsObj = {
			default: 2,
			5039: 19,
			4787: 18,
			4535: 17,
			4283: 16,
			4031: 15,
			3779: 14,
			3527: 13,
			3275: 12,
			3023: 11,
			2771: 10,
			2519: 9,
			2267: 8,
			2015: 7,
			1763: 6,
			1511: 5,
			1199: 4,
			899: 3,
			699: 2, //699 까지 2개
		};

        const challengebreakpointColumnsObj = {
            default: 1,
            5039: 3,
            1763: 2,
            899: 1,

        };
        let ctag;
		let header_list;
		if (location.pathname == '/challenges') {
			if(headerList.length > 0){
                ctag = headerList[0].ctags;
                header_list = (
					<Suspense
						fallback={
							<img
								className="grid-item"
								src="/img/pixelog-loading-gradation-bg.gif"
								alt="Loading"
							/>
						}
					>
						<MainPixelogChallengeHeaderCard
							dataKey={headerList[0].key}
							created_at={headerList[0].created_at}
							cnt={headerList[0].cnt}
							ctags={headerList[0].ctags}
							tags={headerList[0].tags}
							type={headerList[0].type}
							challenge_created_at={headerList[0].challenge_created_at}
							name={headerList[0].name}
							nick={headerList[0].nick}
							uid={headerList[0].uid}
						/>
					</Suspense>
				);
			}
		}else{
            header_list = headerList.map(
				(itemdata, id) => (
					<MainPixelogHeaderCard
						key={`h` + itemdata.id}
						dataKey={itemdata.key}
						created_at={itemdata.created_at}
						type={itemdata.type}
						name={itemdata.name}
					/>
				)
			);
		}

		const headerbreakpointColumnsObj = {
			default: 2,
			5040: 20,
			4788: 20,
			4536: 20,
			4284: 20,
			4032: 19,
			3780: 18,
			3528: 17,
			3276: 16,
			3024: 15,
			2772: 14,
			2520: 13,
			2268: 12,
			2016: 11,
			1764: 10,
			1512: 9,
			1260: 8,
			1008: 7,
			756: 6,
			504: 5
		};

        let isWeb = window.__pageInfo.isWeb;

		return (
			<Fragment>
				<ReactHelmet title={`AI 그림일기 - PIXELOG.GG - ${pageTitle}`}/>
				<PixelogHeader history={this.props.history}/>

                <div className={location.pathname === '/challenges' ? 'header-container-challenge py-4' : 'header-container py-4'}>
                {
                    location.pathname == '/challenges' ?
                    (
                        <Fragment>
                        <div className="row challenge-img-container">
                            <div className={'challenge-img'}></div>
                            {header_list}

                            <div className="col-12">
                                <div className="neo neo-title challenge-title">
                                    CHALLENGE: {ctag}
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 mt-3">
                            <div className="col-12">
                                <div className="neo neo-contents challenge-title">
                                    태그에 <span className="badge bg-primary bg-gradient" style={{fontWeight: "500 !important", padding: "2px", marginRight: "5px" }}>{ctag}</span>를 추가하세요!
                                </div>
                            </div>
                        </div>
                        </Fragment>
                    )
                    :
                    (
                        <Fragment>
                        <div className="row m-0">
                            <Masonry
                                breakpointCols={headerbreakpointColumnsObj}
                                className="my-masonry-grid main-masonry-diagonal"
                                columnClassName=""
                            >
                                {header_list}
                            </Masonry>
                        </div>
                        </Fragment>
                    )
                }

                <div className="d-flex flex-column align-items-center">
                    {location.pathname !== '/challenges' && (
                        <Fragment>
                            <div className="neo neo-title">pixelog</div>
                            <div className="neo neo-contents">오늘을 픽셀로 기록해 보세요!</div>
                        </Fragment>
                    )}
                    {/* 공통 */}
					<div className={`${location.pathname === '/challenges' ? 'challenge-title mt-5' : 'mt-2'} w-100 row m-0 justify-content-sm-center`}>
						<div className="col-12 col-sm-4 col-md-3 col-lg-2 main-btn-left">
							<a id="google-main-make" className="text-decoration-none" href="/pixelog">
								<div className="neo neo-contents btn btn-outline-primary" style={{"border": "none"}}>▶ 그리기</div>
							</a>
						</div>
						{
							winUid !== null ?
								(
									<div className="col-12 col-sm-auto">
										<a id="google-main-ai" className="text-decoration-none" href="/ai/create">
											<div className="ms-2 btn btn-outline-primary"
												 style={{"border": "none"}}>
												<span className="neo neo-contents">▶ AI</span>
												<svg
													stroke="black"
													strokeWidth="1.5px"
													viewBox="1 0 22 22"
													className="main-btn-sparkles beat-fade"
													xmlns="http://www.w3.org/2000/svg"
													width="1.3em"
													height="100%"
													fill="currentcolor"
													style={{
														flexShrink: 0,
														transform: 'scaleX(-1)',
														verticalAlign: '0.15em'
													}}
												>
													<g>
														<path d="M10.4563 5.72844C10.9113 5.57094 10.9113 5.29094 10.4563 5.11594L7.98881 4.17094C7.55131 4.01344 7.04381 3.50594 6.86881 3.05094L5.92381 0.583437C5.76631 0.128438 5.48631 0.128438 5.31131 0.583437L4.36631 3.05094C4.20881 3.48844 3.70131 3.99594 3.24631 4.17094L0.778811 5.11594C0.323811 5.27344 0.323811 5.55344 0.778811 5.72844L3.24631 6.67344C3.68381 6.83094 4.19131 7.33844 4.36631 7.79344L5.31131 10.2609C5.46881 10.7159 5.74881 10.7159 5.92381 10.2609L6.86881 7.79344C7.02631 7.35594 7.53381 6.84844 7.98881 6.67344L10.4563 5.72844Z"></path>
														<path d="M22.4788 14.3734C23.8788 14.0234 23.8788 13.4459 22.4788 13.0959L19.3813 12.3259C17.9813 11.9759 16.5463 10.5409 16.1963 9.14091L15.4263 6.04341C15.0763 4.64341 14.4988 4.64341 14.1488 6.04341L13.3788 9.14091C13.0288 10.5409 11.5938 11.9759 10.1938 12.3259L7.09631 13.0959C5.69631 13.4459 5.69631 14.0234 7.09631 14.3734L10.1938 15.1434C11.5938 15.4934 13.0288 16.9284 13.3788 18.3284L14.1488 21.4259C14.4988 22.8259 15.0763 22.8259 15.4263 21.4259L16.1963 18.3284C16.5463 16.9284 17.9813 15.4934 19.3813 15.1434L22.4788 14.3734Z"></path>
													</g>
												</svg>
												<span className="neo neo-contents"> 그리기</span>
											</div>
										</a>
									</div>
								) :
								(
									<div className="col-12 col-sm-auto">
										<a id="google-main-ai"
										   className="text-decoration-none"
										   onClick={this.showLoginModal}>
											<div className="ms-2 btn btn-outline-primary"
												 style={{"border": "none"}}>
												<span className="neo neo-contents">▶ AI</span>
                                                <svg
                                                    stroke="black"
                                                    strokeWidth="1.5px"
                                                    viewBox="1 0 22 22"
                                                    className="main-btn-sparkles beat-fade"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="1.3em"
                                                    height="100%"
                                                    fill="currentcolor"
                                                    style={{
                                                        flexShrink: 0,
                                                        transform: 'scaleX(-1)',
                                                        verticalAlign: '0.15em'
                                                    }}
                                                >
													<g>
														<path d="M10.4563 5.72844C10.9113 5.57094 10.9113 5.29094 10.4563 5.11594L7.98881 4.17094C7.55131 4.01344 7.04381 3.50594 6.86881 3.05094L5.92381 0.583437C5.76631 0.128438 5.48631 0.128438 5.31131 0.583437L4.36631 3.05094C4.20881 3.48844 3.70131 3.99594 3.24631 4.17094L0.778811 5.11594C0.323811 5.27344 0.323811 5.55344 0.778811 5.72844L3.24631 6.67344C3.68381 6.83094 4.19131 7.33844 4.36631 7.79344L5.31131 10.2609C5.46881 10.7159 5.74881 10.7159 5.92381 10.2609L6.86881 7.79344C7.02631 7.35594 7.53381 6.84844 7.98881 6.67344L10.4563 5.72844Z"></path>
														<path d="M22.4788 14.3734C23.8788 14.0234 23.8788 13.4459 22.4788 13.0959L19.3813 12.3259C17.9813 11.9759 16.5463 10.5409 16.1963 9.14091L15.4263 6.04341C15.0763 4.64341 14.4988 4.64341 14.1488 6.04341L13.3788 9.14091C13.0288 10.5409 11.5938 11.9759 10.1938 12.3259L7.09631 13.0959C5.69631 13.4459 5.69631 14.0234 7.09631 14.3734L10.1938 15.1434C11.5938 15.4934 13.0288 16.9284 13.3788 18.3284L14.1488 21.4259C14.4988 22.8259 15.0763 22.8259 15.4263 21.4259L16.1963 18.3284C16.5463 16.9284 17.9813 15.4934 19.3813 15.1434L22.4788 14.3734Z"></path>
													</g>
												</svg>
												<span className="neo neo-contents"> 그리기</span>
											</div>
										</a>
									</div>
								)
						}
						<div className="col-12 col-sm-4 col-md-3 col-lg-2 main-btn-right">
							<a id="google-main-join" className="text-decoration-none" href="/user/login">
								<div className="neo neo-contents ms-2 btn btn-outline-primary" style={{"border": "none"}}>▶  회원가입</div>
							</a>
						</div>

                        <div className="col-12 mt-3 mt-sm-5 mb-3 d-flex justify-content-evenly justify-content-sm-center align-self-end">
                            { platform.os.family === 'Android' && isWeb && (
                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.pixelog.pixelogapp">
                                    <img src="/img/playstore-ko.png" height="40" alt="PIXELOG.GG App download" />
                                </a>
                                )
                            }
                            { platform.os.family === 'iOS' && isWeb &&(
                                <a target="_blank" href="https://apps.apple.com/kr/app/ai-%EA%B7%B8%EB%A6%BC%EC%9D%BC%EA%B8%B0-%ED%94%BD%EC%85%80%EB%A1%9C%EA%B7%B8/id6475256394?platform=iphone">
                                    <img src="/img/appstore-ko-white.png" height="40" alt="PIXELOG.GG App download" />
                                </a>
                                )
                            }
                            { platform.os.family !== 'iOS' && platform.os.family !== 'Android' && isWeb && (
                                <>
                                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.pixelog.pixelogapp">
                                        <img src="/img/playstore-ko.png" height="40" alt="PIXELOG.GG App download" />
                                    </a>
                                    <a target="_blank" href="https://apps.apple.com/kr/app/ai-%EA%B7%B8%EB%A6%BC%EC%9D%BC%EA%B8%B0-%ED%94%BD%EC%85%80%EB%A1%9C%EA%B7%B8/id6475256394?platform=iphone">
                                        <img className={'ms-sm-5'} src="/img/appstore-ko.svg" height="40" alt="PIXELOG.GG App download" />
                                    </a>
                                </>
                                )
                            }
                        </div>
					</div>
                </div>
            </div>


				<InfiniteScroll
					dataLength={this.state.ItemList.length} //This is important field to render the next data
					next={this.loadDataNext}
					// scrollThreshold="100%"
					style={{overflow: 'visible', position: 'relative'}}
					hasMore={this.state.hasMore}
					loader={
						<div className="spin-container pb-3">
							<div className="spinner-border"
								 style={{"width": "3rem", "height": "3rem"}}
								 role="status"></div>
						</div>
					}
					// endMessage={
					//   <p style={{ textAlign: 'center' }}>
					//     <b>마지막 페이지 입니다.</b>
					//   </p>
					// }
				>
                    <div id="menu-container" className={`${location.pathname === '/challenges' ? 'challenge-menu-container' : ''} row justify-content-center menu-container`}>
                        <div className="col-auto">
                            <div className="menu-container-inner">
                                <Swiper
                                    slidesPerView={'auto'}
                                    navigation
                                >
                                    <SwiperSlide className="">
                                        <Link
                                            to={{
                                                pathname: `/`,
                                                state: {
                                                    cate: 'mainNEW',
                                                }
                                            }}
                                            onClick={this.menuClick}
                                            id='google-main-NEW'
                                            aria-label={'새 글 목록'}
                                        >
                                            <div className={`border border-dark rounded main-menu main-menu-new ${location.pathname == '/' ? 'bg-primary bg-gradient-pixelog' : 'bg-secondary' }`}>
                                                <img src="/img/pixelog-menu-new.png" alt="새 글 목록 버튼"/>
                                            </div>
                                        </Link>
                                    </SwiperSlide>

                                    <SwiperSlide className="ms-2">
                                        <Link
                                            to={{
                                                pathname: `/diary`,
                                                state: {
                                                    cate: 'mainDIARY',
                                                }
                                            }}
                                            onClick={this.menuClick}
                                            id='google-main-DIARY'
                                            aria-label={'일기 목록'}
                                        >
                                            <div className={`border border-dark rounded main-menu ${location.pathname == '/diary' ? 'bg-primary bg-gradient-pixelog' : 'bg-secondary'}`}>
                                                <img src="/img/pixelog-menu-diary.png" alt="일기 목록 버튼"/>
                                            </div>
                                        </Link>
                                    </SwiperSlide>

                                    <SwiperSlide className="ms-2" style={{width: "165px"}}>
                                        <Link
                                            to={{
                                                pathname: `/challenges`,
                                                state: {
                                                    cate: 'mainCHALLENGES',
                                                }
                                            }}
                                            onClick={this.menuClick}
                                            id='google-main-CHALLENGES'
                                            aria-label={'챌린지 목록'}
                                        >
                                            <div className={`border border-dark rounded main-menu ${location.pathname == '/challenges' ? 'bg-primary bg-gradient-pixelog' : 'bg-secondary'}`}>
                                                <img src="/img/pixelog-menu-challenges.png" alt="챌린지 목록 버튼"/>
                                            </div>
                                        </Link>
                                    </SwiperSlide>

                                    <SwiperSlide className="ms-2">
                                        <Link
                                            to={{
                                                pathname: `/likes`,
                                                state: {
                                                    cate: 'mainLIKES',
                                                }
                                            }}
                                            onClick={this.menuClick}
                                            id='google-main-LIKES'
                                            aria-label={'추천글 목록'}
                                        >
                                            <div className={`border border-dark rounded main-menu ${location.pathname == '/likes' ? 'bg-primary bg-gradient-pixelog' : 'bg-secondary'}`}>
                                                <img src="/img/pixelog-menu-likes.png" alt="추천글 목록 버튼"/>
                                            </div>
                                        </Link>
                                    </SwiperSlide>

                                    <SwiperSlide className="ms-2">
                                        <Link
                                            to={{
                                                pathname: `/tags`,
                                                state: {
                                                    cate: 'mainTAGS',
                                                }
                                            }}
                                            onClick={this.menuClick}
                                            id='google-main-TAGS'
                                            aria-label={'태그 목록'}
                                        >
                                            <div className={`border border-dark rounded main-menu ${location.pathname == '/tags' ? 'bg-primary bg-gradient-pixelog' : 'bg-secondary'}`}>
                                                <img src="/img/pixelog-menu-tags.png" alt="태그 목록 버튼"/>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                </Swiper>

                            </div>
                        </div>
                    </div>

					{
						location.pathname == '/likes' &&
						(
							<div className="my-masonry-grid grid mb-2">
								<select className="form-select"
										style={{"width": "154px", "boxShadow": "5px 5px 5px rgba(0,0,0,.125)"}}
										value={this.state.sort}
										onChange={this.handleChange}>
									<option value="1">오늘</option>
									<option value="7">지난 7일</option>
									<option value="30">지난 30일</option>
									<option value="365">지난 1년</option>
									<option value="all">전체</option>
								</select>
							</div>
						)
					}

					{
						loading == false ?
							(
								<div style={{"height": "500px"}} className="spin-container pt-5 pb-5">
									<div className="spinner-border"
										 style={{"width": "3rem", "height": "3rem"}}
										 role="status"></div>
								</div>
							)
							:
							(
                                <div className="row m-0 justify-content-sm-center">
                                    {/* 메인 리스트 */}
                                    <div className="col-12 col-sm-auto m-0 p-0">
                                        <Masonry
                                            breakpointCols={location.pathname === '/challenges' ? challengebreakpointColumnsObj : breakpointColumnsObj}
                                            className="my-masonry-grid grid row gx-2"
                                            columnClassName=""
                                        >
                                            {list}
                                        </Masonry>
                                    </div>

                                    {
                                        isWeb &&
                                        (
                                            <Fragment>
                                            {/* 메인 광고 */}
                                            <div className="col-12 col-sm-3 col-xl-4 m-0 col-ad-list pe-0">
                                                {/*-------------- ------------ sm -------------- ------------*/}
                                                {/* 메인 리스트 광고1 PC 125 X 125 */}
                                                <div className="card ad-list-container-small d-none d-sm-block d-xl-none">
                                                    <div className="card-body p-0">
                                                        <h5 className="ad-card-title text-start">광고</h5>
                                                        <div className="ad-list ad-list-1">
                                                            <AdSense.Google
                                                                className=''
                                                                client='ca-pub-9216699597615631'
                                                                slot='9775284604'
                                                                style={{display: 'flex', width: '125px', height: '125px'}}
                                                                format=''
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* 메인 리스트 광고2 PC 120 X 600 */}
                                                <div className="card ad-list-container d-none d-sm-block d-md-none">
                                                    <div className="card-body p-0">
                                                        <h5 className="ad-card-title text-start">광고</h5>
                                                        <div className="ad-list ad-list-2">
                                                            <AdSense.Google
                                                                className=''
                                                                client='ca-pub-9216699597615631'
                                                                slot='6642821434'
                                                                style={{display: 'flex', width: '120px', height: '600px'}}
                                                                format=''
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*-------------- ------------ md -------------- ------------*/}
                                                {/* 메인 리스트 광고2 PC 160 X 600 */}
                                                <div className="card ad-list-container d-none d-md-block d-xl-none">
                                                    <div className="card-body p-0">
                                                        <h5 className="ad-card-title text-start">광고</h5>
                                                        <div className="ad-list ad-list-2">
                                                            <AdSense.Google
                                                                className=''
                                                                client='ca-pub-9216699597615631'
                                                                slot='9910375342'
                                                                style={{display: 'flex', width: '160px', height: '600px'}}
                                                                format=''
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*-------------- ------------ xl -------------- ------------*/}
                                                {/* 메인 리스트 광고2 PC 300 X 600 */}
                                                <div className="card ad-list-container d-none d-xl-block">
                                                    <div className="card-body p-0">
                                                        <h5 className="ad-card-title text-start">광고</h5>
                                                        <div className="ad-list ad-list-2">
                                                            <AdSense.Google
                                                                className=''
                                                                client='ca-pub-9216699597615631'
                                                                slot='3536538687'
                                                                style={{display: 'flex', width: '300px', height: '600px'}}
                                                                format=''
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </Fragment>
                                        )
                                    }
                                </div>
							)
					}
				</InfiniteScroll>
			</Fragment>
		);
	}
}

MainPixelogList.propTypes = {
	history: ReactRouterPropTypes.history.isRequired,
	location: ReactRouterPropTypes.location.isRequired,
};

export default MainPixelogList;